import { combineReducers } from 'redux';

import reducerDeclaracoes from './reducerDeclaracoes';
import reducerControleTelas from './reducerControleTelas';

const appReducers = combineReducers({
  declaracoesData: reducerDeclaracoes,
  controleTela: reducerControleTelas
});

const rootReducer = (state, action) => {
  return appReducers(state, action);
};

export default rootReducer;
